export const enum LoadingState {
  Error,
  Pending,
  Success,
}
